import { isCanceledOrDeleted } from "@stores/purchases/utils";
import { ReactElement } from "react";
import AccordionCustom from "@common/components/thirdParty/mantine/accordion/AccordionCustom";
import AccordionHeader from "@common/components/thirdParty/mantine/accordion/AccordionHeader";
import DisabledContainer from "@common/components/layout/DisabledContainer";
import { IPurchaseCardProps } from "../types";
import { getPurchaseCardId } from "../utils";
import CanceledSubscriptionSection from "../section/CanceledSubscriptionSection";
import SubscriptionSection from "../section/SubscriptionSection";
import ContactSalesSubscriptionSection from "../section/ContactSalesSubscriptionSection";
import TokenSubscriptionSection from "../section/TokenSubscriptionSection";
import PurchaseStatus from "../section/PurchaseStatus";

export default function EnterpriseSelfHostedPurchaseCard({
  purchase,
  account,
  paymentMethod,
}: IPurchaseCardProps): ReactElement {
  if (purchase.hosted_instance) {
    throw new Error(
      "EnterpriseSelfHostedPurchaseCard, purchase is not self-hosted",
    );
  }

  const { id, token } = purchase;

  if (!token) {
    throw new Error("EnterpriseSelfHostedPurchaseCard, token is undefined");
  }

  const isPurchaseCanceledOrDeleted = isCanceledOrDeleted(purchase);

  return (
    <DisabledContainer
      key={id}
      disabled={isPurchaseCanceledOrDeleted}
      data-testid="PurchaseCard"
    >
      <AccordionCustom id={getPurchaseCardId(purchase)}>
        <AccordionHeader
          data-testid="PurchaseCard_header"
          title="Self-hosted enterprise instance"
          externalLink={!isPurchaseCanceledOrDeleted}
        >
          <PurchaseStatus purchase={purchase} />
        </AccordionHeader>

        <TokenSubscriptionSection purchase={purchase} />

        {isPurchaseCanceledOrDeleted ? (
          <CanceledSubscriptionSection purchase={purchase} />
        ) : (
          <SubscriptionSection
            purchase={purchase}
            account={account}
            paymentMethod={paymentMethod}
          />
        )}

        <ContactSalesSubscriptionSection />
      </AccordionCustom>
    </DisabledContainer>
  );
}
